import { useState, useRef, useEffect } from "react";
import introVideo from "../assets/video-1.mp4";

function VideoIntro({ onComplete }) {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);
  const videoRef = useRef(null);

  // Check if already seen this session
  useEffect(() => {
    const seen = sessionStorage.getItem("intro_seen");
    if (seen) {
      setVisible(false);
      onComplete();
    }
  }, [onComplete]);

  const handleEnd = () => {
    setFading(true);
    sessionStorage.setItem("intro_seen", "true");
    // Wait for fade animation to finish
    setTimeout(() => {
      setVisible(false);
      onComplete();
    }, 800);
  };

  const handleSkip = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    handleEnd();
  };

  if (!visible) return null;

  return (
    <div className={`video-intro ${fading ? "video-intro--fading" : ""}`}>
      <video
        ref={videoRef}
        className="video-intro__video"
        autoPlay
        muted
        playsInline
        onEnded={handleEnd}
      >
        <source src={introVideo} type="video/mp4" />
      </video>

      <button className="video-intro__skip" onClick={handleSkip}>
        Skip
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 4l10 8-10 8V4z" />
          <line x1="19" y1="5" x2="19" y2="19" />
        </svg>
      </button>
    </div>
  );
}

export default VideoIntro;
